/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdatePaymentMethodBody
 */
export interface UpdatePaymentMethodBody {
    /**
     * 
     * @type {number}
     * @memberof UpdatePaymentMethodBody
     */
    expMonth: number;
    /**
     * 
     * @type {number}
     * @memberof UpdatePaymentMethodBody
     */
    expYear: number;
}

export function UpdatePaymentMethodBodyFromJSON(json: any): UpdatePaymentMethodBody {
    return UpdatePaymentMethodBodyFromJSONTyped(json, false);
}

export function UpdatePaymentMethodBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdatePaymentMethodBody {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'expMonth': json['expMonth'],
        'expYear': json['expYear'],
    };
}

export function UpdatePaymentMethodBodyToJSON(value?: UpdatePaymentMethodBody | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'expMonth': value.expMonth,
        'expYear': value.expYear,
    };
}


